module.exports = __webpack_public_path__ + "img/growcify-website-11-banner.282e0510.png";